<div class="main-content">
  <div class="main-header">Config Compare <div class="tooltip"><img src="./assets/Info.svg" alt="Image 1" /><span
        class="tooltiptext">Compare configurations for two cloud instances</span></div>
    <span class="t-r" style="cursor: pointer;">
      <img alt="img" style="vertical-align: middle;" src="./assets/Home.svg" [routerLink]="['']"
        [queryParams]="isTrainStopUrl? queryParams: ''" (click)="maskPage()"></span>
  </div>
  <div class="" style="margin-top: 47px;">
    <div>
      <div class="section ">
        <div class="content">
          <div class="sub-text-600">Select Existing Batch Key in Process</div>
          <div class="search-container">
            <div class="search-content">
              <input type="search" name="searchText" autocomplete="off" (keyup.enter)="search(searchText)"
                (input)="searchOnInput($event.target.value)" [(ngModel)]="searchText" placeholder="Search Batch Key"
                class="search" />
              <button [disabled]="!searchText" (click)="search(searchText)" mat-flat-button class="green-button"
                style="width:95px; margin-left: 24px;">Search</button>
            </div>
            <div class="refresh-container">
              <a style="cursor: hand; cursor:pointer" *ngIf="refresh === true && dataSourceCompareWorkBook.filteredData.length > 0" (click)="onRefresh()"><img
                alt="img" src="./assets/Refresh.svg"></a>
            </div>
          </div>

          <div *ngIf="compareWorkbookData.length>0">
            <div class="table-wrapper">
              <div class="table-container">
                <table style="width:100%">
                  <caption></caption>
                  <thead>
                    <th style="width:25%">
                      Batch Key
                    </th>

                    <th *ngFor="let filter of filterSelectObjForCompare; let i=index;">
                      <span> {{filter.name}} </span>
                      <select class="select-css" [(ngModel)]="filter.modelValue" (change)="filterChange(filter,$event)">
                        <option *ngFor="let item of filter.options; let i=index" [value]="item">{{item}}</option>
                      </select>
                    </th>
                    <th style="width:8%">
                      Date

                    </th>
                    <th style="width:7%" class="action">
                      Action
                    </th>
                  </thead>
                  <tr *ngIf="dataSourceCompareWorkBook.filteredData.length == 0">
                    <td colspan="6"><span class="recordstext">No records found</span></td>
                  </tr>
                </table>
              </div>
              <div style="border: 5px solid rgba(208, 208, 206, 0.35);">
                <table mat-table matSort
                  [dataSource]="tableData |  paginate: { itemsPerPage: size, currentPage: p, totalItems: dataSourceCompareWorkBook.filteredData.length}"
                  style="text-align: left;" *ngIf="refresh" aria-hidden="true">
                <caption></caption>
                  <ng-container matColumnDef="batch_key">
                    <td mat-cell *matCellDef="let element" [ngClass]="'w-25'"> <a class="projectId"
                        (click)="onClickCompareBatchKey(element)">{{element.batch_key}}</a>
                        <a class="details-info"><img title="Config Details" src="./assets/details_Info.svg" alt="Image 1" (click)="tasklistPopup(element.batch_key)"/></a></td>
                  </ng-container>

                  <ng-container matColumnDef="compare_status">
                    <td mat-cell *matCellDef="let element" [ngClass]="'w-28'"> {{element.compare_status}}</td>
                  </ng-container>

                  <ng-container matColumnDef="source_instance">
                    <td mat-cell *matCellDef="let element" [ngClass]="'w-16'"> {{element.source_instance}}</td>
                  </ng-container>

                  <ng-container matColumnDef="target_instance">
                    <td mat-cell *matCellDef="let element" [ngClass]="'w-16'"> {{element.target_instance}}</td>
                  </ng-container>

                  <ng-container matColumnDef="creation_date">
                    <td mat-cell *matCellDef="let element" [ngClass]="'w-8'"> {{element.creation_date | date
                      :'dd/MM/yyyy'}}</td>
                  </ng-container>
                  <ng-container matColumnDef="action">
                    <td mat-cell *matCellDef="let element; index as i" [ngClass]="'w-7 action'">
                      <img alt="img"
                        *ngIf="element.compare_status === 'Cloud Compare - In Progress' || element.compare_status === 'Cloud Compare - Process Submitted' || element.compare_status === 'New' || element.compare_status === 'File Compare - Process Submitted' || element.compare_status === 'File Compare - In Progress'" 
                        src="./assets/Download-Disabled.svg">
                        <img alt="img" style="cursor: pointer;" (click)="getDownloadDropdown(i)" *ngIf="element.compare_status === 'Cloud Compare - Error' || element.compare_status ==='File Compare - Error'|| element.compare_status === 'Bot Fail'"
                        src="./assets/Download.svg">
                        <img alt="img" *ngIf="element.compare_status === 'Cloud Compare - Complete' || element.compare_status === 'File Compare - Complete'|| element.compare_status === 'Cloud Compare - Completed'"
                        style="cursor: pointer;" (click)="getDownloadDropdown(i)" src="./assets/Download.svg">

                      <article *ngIf="hideme ===i" (window:mouseup)="autoCloseForDropdownCars($event)"
                        style="position: relative;">
                        <article class="shadow-bg download-enhancement">
                          <ul class="clearfix list-f m0 list-pn download-list">
                            <li *ngIf="element.downloadAll" (click)="downloadFiles(element.module, element.batch_key)">
                              Download All
                              <img alt=""
                                src="./assets/Download.svg"
                                style="vertical-align: middle; float: right; cursor: pointer;">
                            </li>
                            <li class="active" *ngFor="let item1 of element.module"> <img
                                *ngIf="(item1.success_count ===0 && item1.application !=='Error') || (item1.application === 'Error' && (!item1.output_file_path || !item1.fileList.length))"
                               alt="img" src="./assets/Download-Disabled.svg"
                                style="vertical-align: middle; float: right; cursor: pointer;">
                              <img alt="img"
                                *ngIf="(item1.application ==='Error' && item1.output_file_path && item1.fileList.length) || (item1.success_count !=0 && item1.application !=='Error')"
                                (click)="downloadFiles(item1, element.batch_key)" src="./assets/Download.svg"
                                style="vertical-align: middle; float: right; cursor: pointer;"><span
                                [ngClass]="item1.application == 'Error' ? 'red-t' : ''">{{item1.application}} </span>
                              <span *ngIf="item1.application !=='Error'">
                                ({{item1.success_count}}/{{item1.total_count}})</span>

                            </li>
                          </ul>
                        </article>

                      </article>

                    </td>
                  </ng-container>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


                </table>
              </div>
              <div class="pagenation-container" *ngIf="dataSourceCompareWorkBook.filteredData.length>5">
                <table style="width:100%">
                  <caption></caption>
                  <thead>
                    <th style="width:100%">
                      <pagination-controls (pageChange)="p = $event;paginate(p)"></pagination-controls>
                    </th>
                  </thead>
                </table>
              </div>
            </div>
            <div class="mt32">
              <button mat-flat-button class="green-button btnPos" [disabled]="compareBtnDisable"
                (click)="compareConfigClick()"> Compare Cloud Configurations </button>
            </div>
          </div>

          <div *ngIf="failedToFetchCompare" class="empty-container">
            <div>
              <img alt="img" src="./assets/Not Found.svg">
            </div>
            <div class="empty-container-content">
              <span>Something went wrong!</span>
              <button (click)="getCompareBatchkeys()" mat-flat-button class="green-button-try">Try Again</button>
            </div>
          </div>

          <div *ngIf="compareWorkbookData.length<1 && !noCompareCreated" class="empty-container">
            <div>
              <img alt="img" src="./assets/Not Found.svg">
            </div>
            <div class="empty-container-content">
              <span>No config compare yet!</span>
              <button mat-flat-button class="green-button" (click)="compareConfigClick()"> Compare Cloud Configurations
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
